<template>
  <div class="join">
    <!-- 顶部提示banner -->
    <div class="page-heading" style="background-image: url('static/menhu/images/jm1.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 >奠基中国好门新未来</h1>
            <span >Lay the foundation in China Good Gate New Future</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 加盟简语 -->
    <div class="jm_jydiv">
      <p class="jm_jydiv_title">加盟梵蒂斯，为居者打造梦想之门</p>
      <p class="jm_jydiv_desc">浙江华威门业集团有限公司是一家集自主设计、研发、生产与营销服务于一体高新技术型现代化企业。公司20多年匠心不变，始终坚持走高端入户门研发、生产、销售之路，用品质、服务创造价值。 旗下有“威斯堡”面饰板、“VANTIS·梵蒂斯”恒温智能装甲门、“SEIP”车库门、“梵赫”庭院门四大品牌，有WXQM·五行奇门、布莱斯、布莱斯Ⅱ、布莱斯G、布莱斯GF、Mooy·墨艺铸铝恒温智能装甲门、S mooy·S墨艺铸铝恒温智能装甲门和Fanhe·梵赫庭院门八大系列产品。涵盖装甲铜木、铝木、原木、庭院门，数百种经典款式，具有时尚环保、保温隔音、防潮防火防暴防腐蚀等特点，优异的表面处理技术、先进的设备、超前的设计、精细的工艺，无论款式、性能还是质量均立足行业前沿。 产品遍及国内各重点城市和楼盘，远销国内三十多个省、自治区、直辖市和港、澳、台、东南亚、美州、欧洲，尤以出口欧美与中东的繁盛地域而著称。以门类产品为载体融入美学的氛围装饰现代家居豪宅、别墅装潢，深受品味人士大爱。</p>
      <a class="jm_jydiv_tell" :href="'tel:'+common_platform_data.comp_tell">加盟热线：{{ common_platform_data.comp_tell }}</a>
    </div>

    <!-- 加盟条件 -->
    <div class="jm_tjdiv" >
      <h3 class="jm_tjdiv_head">加盟条件</h3>
      <div class="jm_tjdiv_row" style="background-image: url('static/menhu/images/jm2.png')">
        <div class="jm_tjdiv_item" v-for="(item,index) in jmTjList" :key="index">
          <p class="jm_tjdiv_title">{{ "0"+(index+1) }}</p>
          <p class="jm_tjdiv_desc">{{ item }}</p>
        </div>
      </div>
    </div>

    <!-- 加盟优势 -->
    <div class="lcDiv">
      <h3 style="text-align: center">加盟优势</h3>
      <el-row :gutter="10">
        <el-col v-for="item in 3" :key="index" :sm="24" :md="8">
          <div class="lcItem">
            <i :class="jmysList[item-1].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ jmysList[item-1].name }}</p>
            <p class="lcItem_desc">{{ jmysList[item-1].desc }}</p>
          </div>
        </el-col>
        <el-col v-for="item in 3" :key="index" :sm="24" :md="8">
          <div class="lcItem">
            <i :class="jmysList[item+2].icon+' lcItem_icon'"></i>
            <p class="lcItem_p">{{ jmysList[item+2].name }}</p>
            <p class="lcItem_desc">{{ jmysList[item+2].desc }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 门店形象 -->
    <div class="jmxxdiv">
      <p class="jmxxdiv_t">专卖店形象</p>
      <p class="jmxxdiv_desc1">梵蒂斯短短20几年，超1800个标准专卖店，销售网点逾2000个，店面形象高端大气</p>
      <p class="jmxxdiv_desc2">统计数据截止至：2023年2月7日</p>
      <img class="jmxxdiv_img" src="static/menhu/images/jm3.jpg"/>
    </div>

    <!-- 加盟咨询 -->
    <div class="jmxxdiv" style="margin-top: 15px;padding: 0px 10% 0px 10%">
      <h3 style="text-align: center">申请加盟</h3>
      <Concat concatName="加盟咨询"/>
    </div>

  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import  Concat from '@/components/common_concat';
export default {
  name: 'join',
  components:{Concat},
  data() {
    return {
      common_platform_data:{
        comp_tell:13991953456
      },
      jmTjList:[
        "需要认同梵蒂斯品牌对的经营理念与文化，愿意致力于梵蒂斯品牌的运营，并与公司共同成长；",
        "具有独立的法人资格和从事经营活动的一切证照、手续符合国家的相关法律、法规；",
        "有一定的相关行业经营经验，具有较强的领导、组织和市场运作能力及良好的商业信誉和较强的市场拓展能力，有成熟的业务队伍； 有一定的测量、安装、售后维修能力。建材行业零售经验丰富者优先，有一定综合运营零售经验者优先；",
        "有固定营业场所，具有相当的经济实力，拥有一定的库存空间、销售渠道、销售网点、有配送能力；",
        "能按要求配合公司的各种销售政策、促销活动，完成年度销售任务。"
      ],
      jmysList:[
        {
          name:"加盟支持",
          desc:"我们有着专业的设计团队免费定制店面设计方案；店面运营全程互动支持；全套免费品牌VI设计方案。装修补贴300-1000元每平，免费开业运营指导；丰厚的年终奖金,全国性媒体以及广告全方位的宣传与投放，网络多平台营销与全面推广同步开展",
          icon:"el-icon-s-shop"
        },{
          name:"公司优势",
          desc:"浙江华威门业有限公司创建于1998年，现有三个厂区，古市厂区、松阳永宁厂区、松阳长兴总部，总占地面积139000㎡，总建筑面积约270000㎡，共有员工逾2000人，年产能15万樘，产值10亿左右。",
          icon:"el-icon-trophy"
        },{
          name:"销售优势",
          desc:"我们公司的产品遍及国内各重点城市和高档楼盘，远销国内三十多个省、自治区、直辖市和港、澳、台、东南亚、美州、欧洲，尤以出口欧美与中东的繁盛地域而著称，是您一个放心满意的优质选择",
          icon:"el-icon-coin"
        },{
          name:"研发优势",
          desc:"坚持思维超前设计超前为指导，外聘行业顶尖的企业管理和专业设技术人员，形成了企业独具创新优势的研发生产中心,一流的表面处理技术、先进的设备、超前的设计、精细的工艺，无论款式、性能还是质量均立足行业尖端",
          icon:"el-icon-cpu"
        },{
          name:"运营指导",
          desc:"公司提供装修补贴300-800元每平，免费开业运营指导； 有丰厚的年终奖金； 全国性媒体以及广告全方位的宣传与投放，网络多平台营销与全面推广同步开展",
          icon:"el-icon-guide"
        },{
          name:"售后支持",
          desc:"包含24小时电话服务、长期技术指导服务、定期走访、回访与关怀服务等，公司总部搭建专业的技术支持和客户服务团队，提供线上线下全方位客户服务支持。无论是咨询问题还是售后问题，梵蒂斯客服都会在规定时间内答复。",
          icon:"el-icon-service"
        }
      ]
    }
  }
}
</script>

<style scoped>
.jm_jydiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 5% 10%;
  background: #F8F8F8;
}
.jm_jydiv_title{
  font-size: 24px;
  color: #000000;
  margin-bottom: 40px;
}
.jm_jydiv_desc{
  font-size: 16px;
  color: #666666;
  line-height: 2em;
}
.jm_jydiv_tell{
  font-size: 30px;
  font-family: Arial;
  font-weight: bold;
  color: rgba(8, 40, 65, 1);
}
.jm_tjdiv{
  width: 100%;
  box-sizing: border-box;
  padding: 5% 15%;
}
.jm_tjdiv_row{
  display: flex;
  justify-content: space-between;
}
.jm_tjdiv_item{
  box-sizing: border-box;
  height: 100%;
  padding: 2% 2%;
  border-right: 0.5px solid white;
  flex-grow: 1;
}
.jm_tjdiv_title{
  font-size: 60px;
  font-family: Neuton;
  color: #FFFFFF;
  position: relative;
  margin-bottom: 55px;
}
.jm_tjdiv_title:after {
  content: '';
  display: block;
  width: 28px;
  position: absolute;
  bottom: -30px;
  left: 0;
  border-bottom: 2px solid #008CF9;
}
.jm_tjdiv_desc{
  font-size: 14px;
  color: #FFFFFF;
  line-height: 2.1;
  text-align: justify;
  letter-spacing: -0.02em;
}
.jm_tjdiv_head{
  font-size: 24px;
  color: #000;
  text-align: center;
}

.lcDiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-left: 2%;
  padding-right: 2%;
}

.lcItem{
  width: 100%;
  max-height: 350px;
  box-sizing: border-box;
  background: #F4F4F4;
  padding: 60px 78px;
  text-align: center;
  margin-bottom: 15px;
}

.lcItem:hover p{
  color: white !important;
}
.lcItem:hover i{
  color: white !important;
}
.lcItem:hover{
  background-color: #0f3e68;
}

.lcItem_p{
  color: #000;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 1.583;
  overflow: hidden;
}
.lcItem_desc{
  color: #858585;
  font-size: 14px;
  line-height: 2.15;
  overflow: hidden;
  margin-top: 14px;
}
.lcItem_icon{
  font-size: 55px;
  color: rgba(8, 40, 65, 1);
}
.jmxxdiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  text-align: center;
  padding-bottom: 15px;
  border-bottom: 0.5px solid #D9D9D9;
}
.jmxxdiv_t{
  font-size: 30px;
  color: #000;
}
.jmxxdiv_desc1{
  font-size: 24px;
  font-weight: 300;
  color: #000;
  margin-top: 20px;
  margin-bottom: 40px;
}
.jmxxdiv_desc2{
  font-size: 18px;
  font-weight: lighter;
  color: #666;
}
.jmxxdiv_img{

}

@media only screen and (max-width: 800px) {
  .jm_tjdiv_row{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .lcItem{
    width: 100%;
    max-height: 100vh;
    height: auto;
    box-sizing: border-box;
    background: #F4F4F4;
    padding: 60px 78px;
    text-align: center;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/join.vue